import { render, staticRenderFns } from "./IncomingSMSList.vue?vue&type=template&id=0b68e84e"
import script from "./IncomingSMSList.vue?vue&type=script&lang=js"
export * from "./IncomingSMSList.vue?vue&type=script&lang=js"
import style0 from "./IncomingSMSList.vue?vue&type=style&index=0&id=0b68e84e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports